import { useMutation } from 'react-query';
import axios from 'axios';
import { TerminalAppearanceAPI } from '../../../constants/API';
import { queryClient } from '../../../queryClient';
import { commonHeaders } from '../../../constants/HeadersAPI';
import { useContext } from 'react';
import { AlertContext } from '../../../context/AlertProvider';
import { AlertType } from '../../../types/enums';
import { defaultSuccessMessage } from '../../../constants/alertText';

export const useDeleteTerminalScreensaverMedia = (branchQueueId: number | null) => {
  const context = useContext(AlertContext);

  const {
    mutateAsync: deleteTerminalScreensaverMedia,
    isLoading: isDeleteTerminalScreensaverMediaLoading,
  } = useMutation(
    ['TerminalAppearanceDeleteScreensaver'],
    (mediaId: number) =>
      axios.delete(
        TerminalAppearanceAPI.deleteScreensaverMedia(branchQueueId!, mediaId),
        commonHeaders(),
      ),
    {
      onSuccess: () => {
        queryClient
          .invalidateQueries('TerminalAppearance')
          .then(() =>
            context?.setAlert({
              type: AlertType.Success,
              message: defaultSuccessMessage,
            }),
          );
      },
    },
  );

  return {
    deleteTerminalScreensaverMedia,
    isDeleteTerminalScreensaverMediaLoading,
  };
};
